var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "m-portlet m-portlet--full-height " }, [
      _c("div", { staticClass: "m-portlet__head" }, [
        _c("div", { staticClass: "m-portlet__head-tools" }, [
          _c(
            "ul",
            {
              staticClass:
                "nav nav-pills nav-pills--brand m-nav-pills--align-right m-nav-pills--btn-pill m-nav-pills--btn-sm",
              attrs: { role: "tablist" }
            },
            [
              _c("li", { staticClass: "nav-item m-tabs__item" }, [
                _c(
                  "a",
                  {
                    staticClass: "nav-link m-tabs__link active",
                    attrs: {
                      "data-toggle": "tab",
                      href: "#m_widget5_tab1_content_" + _vm.project.id,
                      role: "tab"
                    }
                  },
                  [
                    _vm._v(
                      "\n                            Übersicht\n                        "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "nav-item m-tabs__item" }, [
                _c(
                  "a",
                  {
                    staticClass: "nav-link m-tabs__link",
                    attrs: {
                      "data-toggle": "tab",
                      href: "#m_widget5_tab2_content_" + _vm.project.id,
                      role: "tab"
                    }
                  },
                  [
                    _vm._v(
                      "\n                            Timetracks\n                        "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "nav-item m-tabs__item" }, [
                _c(
                  "a",
                  {
                    staticClass: "nav-link m-tabs__link",
                    attrs: {
                      "data-toggle": "tab",
                      href: "#m_widget5_tab3_content_" + _vm.project.id,
                      role: "tab"
                    }
                  },
                  [
                    _vm._v(
                      "\n                            Finanzen\n                        "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "nav-item m-tabs__item" }, [
                _c(
                  "a",
                  {
                    staticClass: "nav-link m-tabs__link",
                    attrs: {
                      "data-toggle": "tab",
                      href: "#m_widget5_tab4_content_" + _vm.project.id,
                      role: "tab"
                    }
                  },
                  [
                    _vm._v(
                      "\n                            Tasks\n                        "
                    )
                  ]
                )
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "m-portlet__body" }, [
        _c("div", { staticClass: "tab-content" }, [
          _c(
            "div",
            {
              staticClass: "tab-pane active",
              attrs: {
                id: "m_widget5_tab1_content_" + _vm.project.id,
                "aria-expanded": "true"
              }
            },
            [
              _c("div", { staticClass: "m-widget5" }, [
                _c("div", { staticClass: "m-widget5__item" }, [
                  _c("div", { staticClass: "m-widget5__content" }, [
                    _c("div", { staticClass: "m-widget5__section" }, [
                      _c("h4", { staticClass: "m-widget5__title" }, [
                        _vm._v(
                          _vm._s(_vm.project.clientId) +
                            " / " +
                            _vm._s(_vm.project.projectNumber) +
                            " - "
                        ),
                        _vm.project.clientCompany != ""
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.project.clientCompany))
                            ])
                          : _c("span", [_vm._v(_vm._s(_vm.project.clientName))])
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "m-widget5__desc" }, [
                        _vm._v(
                          "\n                                        " +
                            _vm._s(_vm.project.name) +
                            "\n                                    "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "m-widget5__content pl-0" }, [
                    _c("div", { staticClass: "m-widget5__section" }, [
                      _c("span", { staticClass: "m-widget5__desc pb-2" }, [
                        _c("i", { staticClass: "fa fa-cog" }),
                        _vm._v(
                          "  " +
                            _vm._s(_vm.project.manager) +
                            "\n                                    "
                        )
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "m-widget5__desc" }, [
                        _c("i", { staticClass: "fa fa-camera" }),
                        _vm._v(
                          "  " +
                            _vm._s(_vm.project.photograph) +
                            "\n                                    "
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "m-widget5__item" }, [
                  _c("h4", { staticClass: "m-widget5__title" }, [
                    _vm._v("Angebot")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "m-widget5__content" }, [
                    _c("div", { staticClass: "m-widget5__stats1" }, [
                      _c("span", { staticClass: "m-widget5__number" }, [
                        _vm._v(_vm._s(_vm.project.sollImages))
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "m-widget5__sales" }, [
                        _vm._v("Bilder")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "m-widget5__stats2" }, [
                      _c("span", { staticClass: "m-widget5__number" }, [
                        _vm._v(_vm._s(_vm.project.sollTimetrackHours))
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "m-widget5__votes" }, [
                        _vm._v("Arbeitszeit")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "m-widget5__content" }, [
                    _c("div", { staticClass: "m-widget5__stats1" }, [
                      _c("span", { staticClass: "m-widget5__number" }, [
                        _vm._v(_vm._s(_vm.project.sollSum))
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "m-widget5__sales" }, [
                        _vm._v("Umsatz")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "m-widget5__stats2" }, [
                      parseFloat(_vm.project.sollGewinn) > 0
                        ? _c(
                            "span",
                            {
                              staticClass: "m-widget5__number",
                              staticStyle: { color: "#34bfa3 !important" }
                            },
                            [_vm._v(_vm._s(_vm.project.sollGewinn))]
                          )
                        : _c(
                            "span",
                            {
                              staticClass: "m-widget5__number",
                              staticStyle: { color: "#f4516c !important" }
                            },
                            [_vm._v(_vm._s(_vm.project.sollGewinn))]
                          ),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "m-widget5__votes" }, [
                        _vm._v("Gewinn")
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "m-widget5__item" }, [
                  _c("h4", { staticClass: "m-widget5__title" }, [
                    _vm._v("Ergebnis")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "m-widget5__content" }, [
                    _c("div", { staticClass: "m-widget5__stats1" }, [
                      _c("span", { staticClass: "m-widget5__number" }, [
                        _vm._v(_vm._s(_vm.project.images))
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "m-widget5__sales" }, [
                        _vm._v("Bilder")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "m-widget5__stats2" }, [
                      _c("span", { staticClass: "m-widget5__number" }, [
                        _vm._v(_vm._s(_vm.project.timetrackHours))
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "m-widget5__votes" }, [
                        _vm._v("Arbeitszeit")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "m-widget5__content" }, [
                    _c("div", { staticClass: "m-widget5__stats1" }, [
                      _c("span", { staticClass: "m-widget5__number" }, [
                        _vm._v(_vm._s(_vm.project.sum))
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "m-widget5__sales" }, [
                        _vm._v("Umsatz")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "m-widget5__stats2" }, [
                      parseFloat(_vm.project.gewinn) > 0
                        ? _c(
                            "span",
                            {
                              staticClass: "m-widget5__number",
                              staticStyle: { color: "#34bfa3 !important" }
                            },
                            [_vm._v(_vm._s(_vm.project.gewinn))]
                          )
                        : _c(
                            "span",
                            {
                              staticClass: "m-widget5__number",
                              staticStyle: { color: "#f4516c !important" }
                            },
                            [_vm._v(_vm._s(_vm.project.gewinn))]
                          ),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "m-widget5__votes" }, [
                        _vm._v("Gewinn")
                      ])
                    ])
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tab-pane",
              attrs: {
                id: "m_widget5_tab2_content_" + _vm.project.id,
                "aria-expanded": "false"
              }
            },
            [
              _c(
                "div",
                { staticClass: "m-widget5" },
                _vm._l(_vm.project.timetrackEmployeeArr, function(employee) {
                  return _c(
                    "div",
                    { key: employee.id, staticClass: "m-widget5__item" },
                    [
                      _c("div", { staticClass: "m-widget5__content" }, [
                        _c("div", { staticClass: "m-widget5__section" }, [
                          _c("h4", { staticClass: "m-widget5__title" }, [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(employee.name) +
                                "\n                                    "
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "m-widget5__desc" }, [
                            _c("b", [_vm._v(_vm._s(employee.category) + ":")]),
                            _vm._v(
                              " " +
                                _vm._s(employee.note) +
                                "\n                                    "
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-widget5__content" }, [
                        _c("div", { staticClass: "m-widget5__stats2" }, [
                          _c("span", { staticClass: "m-widget5__number" }, [
                            _vm._v(_vm._s(employee.hoursTrackt))
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", { staticClass: "m-widget5__votes" }, [
                            _vm._v("Zeit")
                          ])
                        ])
                      ])
                    ]
                  )
                }),
                0
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tab-pane",
              attrs: {
                id: "m_widget5_tab3_content_" + _vm.project.id,
                "aria-expanded": "false"
              }
            },
            [
              _c(
                "div",
                { staticClass: "m-widget5" },
                [
                  _vm.project.umsatzNachBild > 0
                    ? _c("div", { staticClass: "m-widget5__item" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget5__content" }, [
                          _c(
                            "div",
                            {
                              staticClass: "m-widget5__stats2",
                              staticStyle: { width: "100%", display: "block" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "m-widget5__number m--font-success"
                                },
                                [_vm._v(_vm._s(_vm.project.umsatzNachBild))]
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", { staticClass: "m-widget5__votes" }, [
                                _vm._v("Bilder Tasks Umsätze")
                              ])
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.project.umsatzNachService > 0
                    ? _c("div", { staticClass: "m-widget5__item" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget5__content" }, [
                          _c(
                            "div",
                            {
                              staticClass: "m-widget5__stats2",
                              staticStyle: { width: "100%", display: "block" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "m-widget5__number m--font-success"
                                },
                                [_vm._v(_vm._s(_vm.project.umsatzNachService))]
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", { staticClass: "m-widget5__votes" }, [
                                _vm._v("Service Tasks Umsätze")
                              ])
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.project.umsatzNachMontage > 0
                    ? _c("div", { staticClass: "m-widget5__item" }, [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget5__content" }, [
                          _c(
                            "div",
                            {
                              staticClass: "m-widget5__stats2",
                              staticStyle: { width: "100%", display: "block" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "m-widget5__number m--font-success"
                                },
                                [_vm._v(_vm._s(_vm.project.umsatzNachMontage))]
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", { staticClass: "m-widget5__votes" }, [
                                _vm._v("Montage Tasks Umsätze")
                              ])
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.project.timetrackEmployeeSumArr, function(
                    employee
                  ) {
                    return _c(
                      "div",
                      { key: employee.id, staticClass: "m-widget5__item" },
                      [
                        _c("div", { staticClass: "m-widget5__content" }, [
                          _c("div", { staticClass: "m-widget5__section" }, [
                            _c("h4", { staticClass: "m-widget5__title" }, [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(employee.name) +
                                  "\n                                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "m-widget5__desc" }, [
                              _vm._v(
                                "\n                                        Kosten des Mitarbeiters anhand der Stunden\n                                    "
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-widget5__content" }, [
                          _c(
                            "div",
                            {
                              staticClass: "m-widget5__stats2",
                              staticStyle: { width: "100%", display: "block" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "m-widget5__number m--font-danger"
                                },
                                [_vm._v(_vm._s(employee.costs))]
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", { staticClass: "m-widget5__votes" }, [
                                _vm._v("Mitarbeiterkosten")
                              ])
                            ]
                          )
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "m-widget5__item" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("div", { staticClass: "m-widget5__content" }, [
                      _c(
                        "div",
                        {
                          staticClass: "m-widget5__stats2",
                          staticStyle: { width: "100%", display: "block" }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "m-widget5__number m--font-danger" },
                            [_vm._v(_vm._s(_vm.project.serviceSum))]
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", { staticClass: "m-widget5__votes" }, [
                            _vm._v("Dienstleisterkosten")
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "m-widget5__item" }, [
                    _vm._m(4),
                    _vm._v(" "),
                    _c("div", { staticClass: "m-widget5__content" }, [
                      _c(
                        "div",
                        {
                          staticClass: "m-widget5__stats2",
                          staticStyle: { width: "100%", display: "block" }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "m-widget5__number m--font-danger" },
                            [_vm._v(_vm._s(_vm.project.gewinn))]
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", { staticClass: "m-widget5__votes" }, [
                            _vm._v("Gewinn")
                          ])
                        ]
                      )
                    ])
                  ])
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tab-pane",
              attrs: {
                id: "m_widget5_tab4_content_" + _vm.project.id,
                "aria-expanded": "false"
              }
            },
            [
              _c(
                "div",
                { staticClass: "m-widget5" },
                _vm._l(_vm.project.tasks, function(task) {
                  return _c("div", { staticClass: "m-widget5__item" }, [
                    _c("div", { staticClass: "m-widget5__content" }, [
                      _c("div", { staticClass: "m-widget5__section" }, [
                        _c("h4", { staticClass: "m-widget5__title" }, [
                          _vm._v(
                            "\n                                        " +
                              _vm._s(task.position) +
                              " - " +
                              _vm._s(task.type) +
                              "\n                                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "m-widget5__desc" }, [
                          _vm._v(_vm._s(task.description))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "m-widget5__content" }, [
                      _c(
                        "div",
                        {
                          staticClass: "m-widget5__stats2",
                          staticStyle: { width: "100%", display: "block" }
                        },
                        [
                          _c("span", { staticClass: "m-widget5__number" }, [
                            _vm._v(_vm._s(task.price) + "€")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", { staticClass: "m-widget5__votes" }, [
                            _vm._v(
                              _vm._s(task.quantity) + " " + _vm._s(task.type)
                            )
                          ])
                        ]
                      )
                    ])
                  ])
                }),
                0
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-widget5__content" }, [
      _c("div", { staticClass: "m-widget5__section" }, [
        _c("h4", { staticClass: "m-widget5__title" }, [
          _vm._v(
            "\n                                        Umsatz Bilder\n                                    "
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "m-widget5__desc" }, [
          _vm._v("Alle Umsätze aus den Tasks Bilder")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-widget5__content" }, [
      _c("div", { staticClass: "m-widget5__section" }, [
        _c("h4", { staticClass: "m-widget5__title" }, [
          _vm._v(
            "\n                                        Umsatz Services\n                                    "
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "m-widget5__desc" }, [
          _vm._v("Alle Umsätze aus den Tasks Services")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-widget5__content" }, [
      _c("div", { staticClass: "m-widget5__section" }, [
        _c("h4", { staticClass: "m-widget5__title" }, [
          _vm._v(
            "\n                                        Umsatz Montagen\n                                    "
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "m-widget5__desc" }, [
          _vm._v("Alle Umsätze aus den Tasks Montagen")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-widget5__content" }, [
      _c("div", { staticClass: "m-widget5__section" }, [
        _c("h4", { staticClass: "m-widget5__title" }, [
          _vm._v(
            "\n                                        Dienstleister\n                                    "
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "m-widget5__desc" }, [
          _vm._v(
            "\n                                        Kosten des Dienstleisters Bildanzahl * Preis pro Bild\n                                    "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-widget5__content" }, [
      _c("div", { staticClass: "m-widget5__section" }, [
        _c("h4", { staticClass: "m-widget5__title" }, [
          _vm._v(
            "\n                                        Billanz\n                                    "
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "m-widget5__desc" }, [
          _vm._v(
            "\n                                        Alle Einnahmen und Ausgaben gegengerechnet\n                                    "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }